import { render, staticRenderFns } from "./MedicalTeamEdit.vue?vue&type=template&id=fcb2852c"
import script from "./MedicalTeamEdit.vue?vue&type=script&lang=js"
export * from "./MedicalTeamEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports